/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { PushHistoryDetail } from './PushHistoryDetail';
import { confirmedAfterReplayRow, linkedRow, platformOnlyRow, suppressedRow } from './fixtures';
const meta = {
    title: 'Features/Settings/Technicians/PushHistory/PushHistoryDetail',
    component: PushHistoryDetail,
    parameters: { layout: 'padded' },
    args: { timeZone: 'America/New_York', platformUnavailable: false, columnCount: 1 },
    decorators: [
        (Story) => (React.createElement("table", { className: "push-history__table" },
            React.createElement("tbody", null,
                React.createElement(Story, null))))
    ]
};
export default meta;
export const Linked = { args: { row: linkedRow } };
export const ConfirmedAfterReplay = { args: { row: confirmedAfterReplayRow } };
export const HeldBack = { args: { row: suppressedRow } };
export const PlatformOnly = { args: { row: platformOnlyRow } };
export const PlatformUnavailable = {
    args: { row: Object.assign(Object.assign({}, linkedRow), { kind: 'rails_only', platform: null }), platformUnavailable: true }
};
